import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../Button'
import AlertDanger from '../NewAlert/AlertDanger'
import AlertDescription from '../NewAlert/AlertDescription'
import AlertTitle from '../NewAlert/AlertTitle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function NewsletterAlertError({ onSubmit }) {
  const { t } = useTranslation()

  return (
    <AlertDanger>
      <FontAwesomeIcon icon={['fal', 'times-circle']} />

      <div>
        <AlertTitle>{t('newsletter.alert.error.title')}</AlertTitle>
        <AlertDescription>{t('newsletter.alert.error.description')}</AlertDescription>
        <Button onClick={onSubmit}>{t('newsletter.alert.error.cta')}</Button>
      </div>
    </AlertDanger>
  )
}

export default NewsletterAlertError
